import {match, MatchFunction} from 'path-to-regexp';

import {ROUTES, RouteDefinition, RouteName} from './table';

export type RouteMatch = {
	name: RouteName;
	params: Record<string, string>;
};

const matchers = new Map<string, MatchFunction<object>>();

function matcher(pattern: string) {
	let fn = matchers.get(pattern);
	if (!fn) {
		fn = match(pattern, {decode: decodeURIComponent});
		matchers.set(pattern, fn);
	}
	return fn;
}

function pathnameOf(url: string): string {
	const pathname = url.split('#')[0].split('?')[0];
	// хвостовой слэш не должен мешать сопоставлению: /classes/ это тот же /classes
	return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

/** Находит маршрут по адресу. Побеждает первый подошедший — порядок задан в ROUTES. */
export function matchUrl(url?: string | null): RouteMatch | null {
	if (!url) return null;
	const pathname = pathnameOf(url);

	for (const route of ROUTES) {
		const result = matcher(route.pattern)(pathname);
		if (result) {
			return {
				name: route.name,
				params: result.params as Record<string, string>,
			};
		}
	}

	return null;
}

/** Определение маршрута по имени — для мест, где имя уже известно. */
export function findRoute(name: string): RouteDefinition | undefined {
	return ROUTES.find((route) => route.name === name);
}
